import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import * as FacilitiesActions from '../../actions/facilities_actions';
import _ from 'lodash';
import Header from '../../components/header';
import { FacilitiesHeader } from '../../components/facilitiesScreen/facility-header';
import { FacilitiList } from './staffFacilitieslist';
import { ModalDialog } from '../modal_dialog';
import { Addfacility } from '../../components/facilitiesScreen/add-facility';
let screenIdentifier = 'staffhome';
import Facilities from '../../components/facilitiesScreen/facilities';


let staffHome = React.createClass({
    getInitialState() {
        return {
            facilitiListLength: false,
            listView: false,
            gridview: true,
            facilitiList: 0,
            toggleView: 0,
            propsRecived: 0,
            toggleClassName: 'grid-view',
            dialog: false,
            add_admin: false,
            add_admin_later: false,
            facilitListItem: null
        }
    },
    componentWillMount() {
        // need to check and removed...
        //this.props.Dispatch(FacilitiesActions.getAllfacilities());
        this.props.Dispatch(FacilitiesActions.getfacilitiesbySearch({
            "searchChar": '',
            "page": 1,
            "size": 9,
        }));
        this.props.FacilitiesDetails.FaciliteDetailsByID = {};
        let AllfacilitDetails = this.props.FacilitiesDetails.FaciliteDetails ? this.props.FacilitiesDetails.FaciliteDetails.data : 0;
        this.setState({ 'facilitListItem': AllfacilitDetails });
        if (!AllfacilitDetails) { this.props.router.push('../../components/facilitiesScreen/add-facility#new') }
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    componentWillReceiveProps(nextProps) {

        var facilitiesDetails = nextProps.FacilitiesDetails;

        let AllfacilitDetails = nextProps.FacilitiesDetails.FaciliteDetails.data;
        this.setState({ 'facilitListItem': AllfacilitDetails });

        if (nextProps.FacilitiesDetails.FaciliteDetailsByID ? nextProps.FacilitiesDetails.FaciliteDetailsByID.status == 200 : false) { this.props.router.push('/facilities/details'); }
    },
    componentDidMount() {

    },

    addNewFacility() {
        this.setState({ facilitiListLength: true })
        this.props.router.push('../../components/facilitiesScreen/add-facility');
    },
    searchFaciliti(event) {

        let value_name = event.target.value.toLowerCase();
        let fillterdList = [];
        var currentlist = this.state.facilitListItem;
        var results = _.filter(currentlist, function (item) {
            return item.name.toLowerCase().indexOf(value_name) > -1 || item.email.toLowerCase().indexOf(value_name) > -1 || item.url.toLowerCase().indexOf(value_name) > -1 || item.mobile.toLowerCase().indexOf(value_name) > -1;
        });

        if (value_name.length == 0) {
            this.setState({ facilitListItem: this.props.FacilitiesDetails.FaciliteDetails.data });
        }
        else { this.setState({ facilitListItem: results }); }

        //  return fillterdList;
    },
    add_dmin(event) {
        //alert('add admin')
        var faciliti_id = event.target.getAttribute("data-facilit-id");
        // this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(faciliti_id));
        this.props.router.push('../../components/facilitiesScreen/facilities/admin/add?id=' + faciliti_id);
    },
    toggleView() {
        var toggleState = this.state.toggleView == 0 ? 1 : 0;

        this.setState({ toggleView: toggleState });

    },
    toggletoList() {

        this.setState({ toggleClassName: 'list-view' });
    },
    toggletoGrid() {
        this.setState({ toggleClassName: 'grid-view' });
    },
    view_faciliti(e) {

        var faciliti_id = e.target.getAttribute("data-facilit-id");
        this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(faciliti_id));
        //this.props.router.push('/facilities/details');

    },

    render() {
        //  var templateAddNew =<Addfacility add={this.addFacility}/>;

        var template = (this.props.FacilitiesDetails.FaciliteDetails ? this.props.FacilitiesDetails.FaciliteDetails.data.length > 0 : false) ? <FacilitiList viewAction={this.view_faciliti} data={this.state.facilitListItem} toggleClass={this.state.toggleClassName} toggletoList={this.toggletoList} toggletoGrid={this.toggletoGrid} addNew={this.addNewFacility} list={this.state.facilitiList} /> : "";
        //  var templateAddNew =<Addfacility add={this.addFacility}/>;
        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} />
                <div className="text-center staff-home"><h3>Select your facility</h3>
                    <p>Please select the facility you want to proceed with.</p></div>
                {this.state.facilitiListLength ? '' : template}

                <div> {this.state.dialog ? <ModalDialog addadmin={this.add_admin} doitlater={this.add_admin_later} /> : ""}
                </div>
            </div>

        );
    }
});

let mapStateToProps = (state) => {

    return {
        FacilitiesDetails: state.Facilites,
        LogingDetails: state.User.loginData,
    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(staffHome));
     // <Header screenIdentifier={screenIdentifier} />



/** WEBPACK FOOTER **
 ** ./src/components/staff/staffHome.js
 **/